"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Erc20ContractDeployDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const mui_inputs_mask_1 = require("@dzambalaorg/mui-inputs-mask");
const types_1 = require("@framework/types");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const Erc20ContractDeployDialog = () => {
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [2, 2], children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "name", required: true }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.SelectInput, { name: "contractTemplate", options: types_1.Erc20ContractTemplates, disabledOptions: [types_1.Erc20ContractTemplates.EXTERNAL], required: true }), (0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "symbol", required: true }), (0, jsx_runtime_1.jsx)(mui_inputs_mask_1.EthInput, { name: "cap", required: true })] }));
};
exports.Erc20ContractDeployDialog = Erc20ContractDeployDialog;
//# sourceMappingURL=index.js.map